module.exports = __webpack_public_path__ + "static/img/huaishuImg3.b6ec510.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/huaishuImg3.png
// module id = YQGY
// module chunks = 0